import "core-js/modules/es6.array.for-each";
export default function (n) {
  return function (t) {
    n.forEach(function (n) {
      "function" == typeof n ? n(t) : null != n && (n.current = t);
    });
  };
}